import React from 'react';
import { useTranslation } from 'react-i18next';

import CasinoDropdownMenu from '../../casino/user/user-panel/CasinoDropdownMenu';
import NotificationBell from '../../notifications/NotificationBell.lazy';

import DropdownMenu from './DropdownMenu';

function AuthorizedPanelDefault({ user, links}) {
    const { t } = useTranslation();
    const notificationsEnabled = process.env.MIX_NOTIFICATIONS_ENABLED === 'true';
    // API now returns amount as integers, so we have to divide to prevent BC
    const legacyBalanceAmount = user ? user.balance.amount / 100 : '';

    function getDropdown() {
        return (
            <div key="dropdown" className="dropdown d-xl-inline-block d-none account-dropdown-menu">
                <span className="btn btn-transparent btn-account">
                    <span className="balance" id="user-balance" data-balance={legacyBalanceAmount}>
                        <i className="fas fa-user fa-lg mr-2" /> {user?.balance.formatted}
                    </span>
                    <i className="fas fa-angle-down arrow" />
                </span>
                {window.IS_CASINO ? (
                    <CasinoDropdownMenu links={links} user={user} />
                ) : (
                    <DropdownMenu links={links} user={user} />
                )}
            </div>
        );
    }
    return (
        <>
            {getDropdown()}
            <div key="balance">
                <a className="btn btn-transparent d-xl-inline-block d-none" href={links?.deposit}>
                    {t('userPanel.makeDeposit')}
                </a>
            </div>
            {notificationsEnabled && <NotificationBell key="notification" />}
        </>
    );
}

export default AuthorizedPanelDefault;
